import { render, staticRenderFns } from "./AudienceDrawer.vue?vue&type=template&id=28c5a9fa&scoped=true"
import script from "./AudienceDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AudienceDrawer.vue?vue&type=style&index=0&id=28c5a9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5a9fa",
  null
  
)

export default component.exports